const contactUs = {
    contactUs: {
        pageTitle: 'Contact Us',
        pageDescription: 'Do you need advice on using IOPS Ground Station?',
        descriptionBanner: 'Please leave your contact information and any questions you have, and we will contact you quickly.',
        form: {
            inquiryType: 'Inquiry Type',
            name: 'Name',
            company: 'Company / Department',
            country: 'Country',
            email: 'Email',
            inquiry: 'Inquiry contents',
            agree: 'I have read and agree to the privacy policy and terms of use.\nRead the Privacy Policy and terms of use below.',
            submit: 'Submit'
        },
        placeholder: {
            country: 'Select a country'
        },
        inquiryType: {
            use: 'Use a ground station',
            share: 'Share a ground station',
            estimate: 'Estimate Inquiry',
            press: 'Make a press inquiry',
            other: 'Other'
        }
    }
}

export default contactUs;